import { render } from "./CashMethod.vue?vue&type=template&id=54e2817f"
import script from "./CashMethod.vue?vue&type=script&lang=js"
export * from "./CashMethod.vue?vue&type=script&lang=js"
script.render = render

export default script